import React from "react";

interface DateOfBirthIconProps {
  className?: string;
}

export const DateOfBirthIcon = ({ className }: DateOfBirthIconProps) => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.3333 23L2.66667 23C1.95942 23 1.28115 22.7592 0.781048 22.3305C0.280951 21.9019 0 21.3205 0 20.7143L0 4.71428C0 4.10807 0.280951 3.52669 0.781048 3.09804C1.28115 2.66938 1.95942 2.42857 2.66667 2.42857L5.33333 2.42857L5.33333 0.142853L8 0.142853L8 2.42857L16 2.42857V0.142853L18.6667 0.142853V2.42857L21.3333 2.42857C22.0406 2.42857 22.7189 2.66938 23.219 3.09804C23.719 3.52669 24 4.10807 24 4.71428L24 20.7143C24 21.3205 23.719 21.9019 23.219 22.3305C22.7189 22.7592 22.0406 23 21.3333 23ZM2.66667 9.28571L2.66667 20.7143L21.3333 20.7143V9.28571L2.66667 9.28571ZM2.66667 4.71428L2.66667 7L21.3333 7V4.71428L2.66667 4.71428ZM18.6667 18.4286H16L16 16.1429H18.6667V18.4286ZM13.3333 18.4286H10.6667L10.6667 16.1429H13.3333L13.3333 18.4286ZM8 18.4286L5.33333 18.4286L5.33333 16.1429L8 16.1429L8 18.4286ZM18.6667 13.8571L16 13.8571V11.5714L18.6667 11.5714V13.8571ZM13.3333 13.8571L10.6667 13.8571V11.5714L13.3333 11.5714V13.8571ZM8 13.8571H5.33333L5.33333 11.5714H8L8 13.8571Z"
      fill="black"
    />
  </svg>
);

DateOfBirthIcon.defaultProps = {
  className: "",
};
